import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { User } from "../../types/User";

export const setMyAIConsent = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    getDataByQueryKey,
    optimisiticUpdateOnMutate,
  } = useAPQuery();

  return useMutation({
    mutationFn: (): Promise<boolean> => {
      return fetchWithAuth<boolean>("setMyAIConsent", undefined, {
        requestOptions: { method: "post" },
      });
    },
    onMutate: async () => {
      const queryKey = ["user"];
      const user = getDataByQueryKey(queryKey) as User;
      const updatedUser: User = {
        ...user,
        aiConsent: true,
      };

      optimisiticUpdateOnMutate(["user"], updatedUser);
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
